import React from 'react'

export function LoadingButtonComponent() {
  return (
    <div className="button-loading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
